import { btnDelay } from "common/utils";
import i18n from "features/shared/i18n";
import { ParentPieceComment } from "features/player/types";
import { ParentPieceCommentRow } from "./ParentPieceCommentRow";

interface PieceCommentsSectionProps {
  comments: ParentPieceComment[];
  onSelectComment: (comment: ParentPieceComment) => void;
  onShowMore: () => void;
}

export const PieceCommentsSection = ({
  comments,
  onSelectComment,
  onShowMore,
}: PieceCommentsSectionProps) => {

  return (
    <div className="bg-white rounded-[16px] p-6">
      <div className="flex-row-el items-center justify-between mb-5 pb-3 border-b border-outline">
        <div className="flex-row-el items-center gap-2 text-[24px] text-textcolor-black">
          <span className="material-symbols-outlined !text-[45px] text-red-100">chat_bubble</span>
          {i18n.t("MSG_PARENT_PAGE_PLAYER_PIECE_COMMENTS")}
          <span className="text-[21px] font-normal text-gray2-100 ml-1">({comments.length})</span>
        </div>
        {comments.length > 3 && (
          <button
            className="flex-row-el items-center gap-1 px-4 py-2 bg-white border border-gray2-60 rounded-full text-[21px] text-textcolor-black cursor-pointer hover:bg-gray2-20 transition-all"
            onClick={() => {
              btnDelay(onShowMore);
            }}
          >
            {i18n.t("MSG_PARENT_PAGE_PLAYER_SHOW_MORE")}
          </button>
        )}
      </div>

      {comments.length > 0 ? (
        <div className="flex-col-el gap-3">
          {comments.slice(0, 3).map((comment) => (
            <ParentPieceCommentRow
              key={comment.id}
              comment={comment}
              onClick={() => {
                btnDelay(() => onSelectComment(comment));
              }}
            />
          ))}
        </div>
      ) : (
        <div className="flex-col-center py-8 text-gray2-100">
          <span className="material-symbols-outlined text-[60px] mb-2">chat_bubble</span>
          <span className="text-[21px]">
            {i18n.t("MSG_PARENT_PAGE_PLAYER_PIECE_COMMENTS_EMPTY")}
          </span>
        </div>
      )}
    </div>
  );
};
